import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class BotIsNotAdminMixin extends Vue {
  botIsNotAdmin(chat: any): boolean {
    return this.$store.state.themeConfig.projectName !== 'infibot' && chat.diagnostic.bot_not_admin
  }
}
